import type {
  StorefrontTagCreateRequestType,
  StorefrontTagCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useStorefrontTagCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: StorefrontTagCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `storefront-tags`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as StorefrontTagCreateResponseType,
      ),
    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.StorefrontTags],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.StorefrontTags,
          response.id,
        ],
      });
    },
  });
};
